import Service from "../service";
// import AuthService from "../AuthServ

const Circumstances = {
    getCircumstances() {
        return Service.get('/cicumstance')
    }
    // getTypeWater(){
    //     return Service.get('/type_water');
    // },
    // getDepartments(){
    //     return Service.get('/departments');
    // },
    // getProvincePatient() {
    //   return Service.get('/province_patient');
    // },
    // getNation() {
    //   return Service.get('/nation');
    // },
    // getHospital(province_code) {
    //   return Service.get('/hospital?province_code='+province_code);
    // }
};


export default Circumstances;
